$(window).on('load', () => {
	if ($('.popUp')[0]) {
		const popupBtn = 'a.popup-btn';
		const popupClose = '.popUp__close, .popUp__overlay';
		const popup = '.popUp';

		$(popupBtn).on('click', function (event) {
			const btnID = this.hash.slice(1);
			if (!btnID) {
				return;
			}
			event.preventDefault();
			const popID = '#modal-' + btnID;
			$(popID).fadeIn();
			$('body').addClass('no-scroll');
		});

		$(popupClose).on('click', function () {
			$(popup).fadeOut();
			if ($('body').hasClass('no-scroll')) {
				$('body').removeClass('no-scroll');
			}
		});

		if ($('.site-popup')[0]) {
			const POPUP_KEY = 'sitePopClosedTime';
			const HOURS_DELAY = 3;

			const lastClosed = localStorage.getItem(POPUP_KEY);

			if (!lastClosed || Date.now() - lastClosed > HOURS_DELAY * 60 * 60 * 1000) {
				setTimeout(function () {
					$('.site-popup').fadeIn();
					$('body').addClass('no-scroll');
				}, 12000);
			}

			$(popupClose).on('click', function () {
				$('.site-popup').fadeOut();
				localStorage.setItem(POPUP_KEY, Date.now());
			});
		}
	}
});
